import { createContext } from 'react';
import NotificationStore from '../Storage/NotificationStore';

const NotificationStoreContext = createContext<NotificationStore>(new NotificationStore());

export default NotificationStoreContext;
